var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessLaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.42 212.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.5,
    y: 38.37,
    width: 238.42,
    height: 169.27,
    rx: 7.93,
    ry: 7.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.05,4.5h57.33c5.83,0,10.57,4.74,10.57,10.57v21.21H84.48V15.07c0-5.83,4.74-10.57,10.57-10.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.92,91.06c0,12.14-9.31,22.26-21.41,23.27l-97.8,8.17-97.8-8.17c-12.1-1.01-21.41-11.13-21.41-23.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.6,115.57v19.09c0,2.48-2.02,4.5-4.5,4.5h-14.77c-2.48,0-4.5-2.02-4.5-4.5v-18.78c0-.1,0-.21,0-.31,0-6.56,5.32-11.88,11.89-11.88s11.89,5.32,11.89,11.88Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLaw);
export default __webpack_public_path__ + "static/media/businessLaw.42317a69db4d13fed20d546cc257883a.svg";
export { ForwardRef as ReactComponent };